var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{class:{
    'dp-table': true,
    'dp-table--small-font': _vm.smallFont,
  }},[(_vm.title)?_c('caption',{staticClass:"dp-table__caption"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }